import type { CSSProperties } from 'react';
import styled from 'styled-components';

import useColor from '@/hooks/domain/useColor';

import { CenterFlex, Flex, Space } from '../../base';
import Spinner from '../../Common/Spinner';
import { MainText } from '../../Typography/NamedTypo';
import Typo from '../../Typography/Typo';

export type ProgressProps = {
  current: number;
  total: number;
  style?: CSSProperties;
  barStyle?: CSSProperties;
  text?: string;
  percent?: boolean;
};

const ProgressBar = (props: ProgressProps) => {
  const color = useColor();
  const percentage = props.total
    ? Number(((props.current / props.total) * 100).toFixed(1))
    : 0;
  return (
    <>
      <ProgressBarWrapper style={props.style}>
        <ProgressBarStyle
          style={{ ...props.barStyle, width: `${percentage}%` }}
        />
      </ProgressBarWrapper>
      {props.text && (
        <>
          <Typo type="label2" color={color.gray700} style={{ marginLeft: 8 }}>
            {props.text}
          </Typo>
          {props.percent && (
            <MainText dim style={{ marginLeft: 4 }}>
              ({percentage.toFixed(1)}%)
            </MainText>
          )}
        </>
      )}
    </>
  );
};

const ProgressBarWrapper = styled(Flex)`
  width: 240px;
  height: 8px;
  border-radius: 4px;
  background-color: ${(props) => props.theme.colors.gray300};
  overflow: hidden;
`;

const ProgressBarStyle = styled.div`
  transition: all 0.2s;
  background-color: ${(props) => props.theme.colors.primaryAlpha(1)};
`;

const ProgressIndicator = (props: ProgressProps) => {
  const color = useColor();
  return (
    <IndicatorStyle d="column">
      <Spinner />
      <Space h={16} />
      <Typo type="label2" color={color.gray600}>
        Uploading...
      </Typo>
      <Space h={32} />
      <ProgressBar {...props} style={{ width: 240 }} />
    </IndicatorStyle>
  );
};

const IndicatorStyle = styled(CenterFlex)`
  width: 100%;
  height: 400px;
`;

export default ProgressBar;

export { ProgressIndicator };
